// extracted by mini-css-extract-plugin
export default {"tabWrapper":"YRe6W_YRe6W","tab":"wZJx4_wZJx4","selected":"Lno7y_Lno7y","tabBtn":"kFbOx_kFbOx"};